import { Genre, TemporalBackground, SpatialBackground, Atmosphere, StoryGoal, MainEvent, Ending } from '../types';

export const getGenreKoreanName = (genre: Genre): string => {
  const genreMap: Record<Genre, string> = {
    [Genre.Thriller]: '스릴러',
    [Genre.Horror]: '호러',
    [Genre.Fantasy]: '판타지',
    [Genre.Comic]: '코믹',
    [Genre.History]: '역사',
    [Genre.Detective]: '추리',
    [Genre.Drama]: '드라마',
    [Genre.Emotional]: '감동',
    [Genre.SF]: 'SF',
    [Genre.Educational]: '교육'
  };

  return genreMap[genre];
};

export const getTemporalBackgroundKoreanName = (temporalBackground: TemporalBackground): string => {
  const temporalMap: Record<TemporalBackground, string> = {
    [TemporalBackground.Prehistoric]: '선사/고대',
    [TemporalBackground.Medieval]: '중세',
    [TemporalBackground.EarlyModern]: '근세/근대',
    [TemporalBackground.Modern]: '현대',
    [TemporalBackground.Future]: '미래'
  };

  return temporalMap[temporalBackground];
};

export const getSpatialBackgroundKoreanName = (spatialBackground: SpatialBackground): string => {
  const spatialMap: Record<SpatialBackground, string> = {
    [SpatialBackground.City]: '도시',
    [SpatialBackground.Countryside]: '시골',
    [SpatialBackground.Village]: '마을',
    [SpatialBackground.School]: '학교',
    [SpatialBackground.Laboratory]: '연구소',
    [SpatialBackground.Hospital]: '병원',
    [SpatialBackground.Museum]: '도서관/박물관',
    [SpatialBackground.Castle]: '성/요새',
    [SpatialBackground.Ruins]: '유적',
    [SpatialBackground.Desert]: '사막',
    [SpatialBackground.Jungle]: '정글',
    [SpatialBackground.Forest]: '숲',
    [SpatialBackground.Glacier]: '빙하',
    [SpatialBackground.Ocean]: '바다',
    [SpatialBackground.Island]: '섬',
    [SpatialBackground.Cave]: '동굴',
    [SpatialBackground.Underground]: '지하',
    [SpatialBackground.Labyrinth]: '미궁',
    [SpatialBackground.OtherPlanet]: '다른 행성',
    [SpatialBackground.VirtualSpace]: '가상공간'
  };

  return spatialMap[spatialBackground];
};

export const getAtmosphereKoreanName = (atmosphere: Atmosphere): string => {
  const atmosphereMap: Record<Atmosphere, string> = {
    [Atmosphere.Joyful]: '즐겁게',
    [Atmosphere.Tense]: '긴장감',
    [Atmosphere.Mysterious]: '미스터리',
    [Atmosphere.Scary]: '무섭게',
    [Atmosphere.Peaceful]: '평화롭게',
    [Atmosphere.Mystical]: '신비롭게',
    [Atmosphere.Warm]: '따뜻하게',
    [Atmosphere.Calm]: '잔잔하게',
    [Atmosphere.Composed]: '차분하게',
    [Atmosphere.Bright]: '밝은',
    [Atmosphere.Hopeful]: '희망차게',
    [Atmosphere.Dreamy]: '몽환적이게',
    [Atmosphere.Cheerful]: '유쾌하게',
    [Atmosphere.Dark]: '어둡게',
    [Atmosphere.Cold]: '차갑게'
  };

  return atmosphereMap[atmosphere];
};

export const getStoryGoalKoreanName = (storyGoal: StoryGoal): string => {
  const storyGoalMap: Record<StoryGoal, string> = {
    [StoryGoal.Rescue]: '구출하기',
    [StoryGoal.FindItem]: '물건찾기',
    [StoryGoal.RevealSecret]: '비밀 밝혀내기',
    [StoryGoal.DiscoverPlace]: '새로운 장소 발견하기',
    [StoryGoal.Investigate]: '수사하기',
    [StoryGoal.PassTest]: '시험 통과하기',
    [StoryGoal.PreventDanger]: '위험 막기',
    [StoryGoal.Escape]: '탈출하기',
    [StoryGoal.Negotiate]: '협상하기',
    [StoryGoal.Custom]: '직접 입력'
  };

  return storyGoalMap[storyGoal];
};

export const getMainEventKoreanName = (mainEvent: MainEvent): string => {
  const mainEventMap: Record<MainEvent, string> = {
    [MainEvent.TimeLimit]: '시간 제한',
    [MainEvent.ComplexMaze]: '복잡한 미로',
    [MainEvent.StrongEnemy]: '강력한 적',
    [MainEvent.Traitor]: '배신자',
    [MainEvent.Trap]: '함정 장치',
    [MainEvent.CodeBreaking]: '암호 해독',
    [MainEvent.NaturalDisaster]: '자연재해',
    [MainEvent.LimitedResources]: '제한된 자원',
    [MainEvent.FalseInformation]: '허위 정보',
    [MainEvent.EnemySurveillance]: '적의 감시',
    [MainEvent.PhysicalCrisis]: '물리적 위기(낙하, 붕괴 등)',
    [MainEvent.ItemLoss]: '물건 분실',
    [MainEvent.Custom]: '직접 입력'
  };

  return mainEventMap[mainEvent];
};

export const getEndingKoreanName = (ending: Ending): string => {
  const endingMap: Record<Ending, string> = {
    [Ending.HappyEnding]: '해피엔딩',
    [Ending.BadEnding]: '배드엔딩',
    [Ending.TwistEnding]: '반전엔딩',
    [Ending.OpenEnding]: '열린 결말'
  };

  return endingMap[ending];
};